module.exports = __webpack_public_path__ + "static/media/download.619b6b5b.svg";